/* ============================================================
   DW Product — variant picker, quick view, sticky ATC
   Works on the PDP and inside the quick-view modal.
   ============================================================ */

(function () {
  'use strict';

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ---- Live stock badge ----
  // Rebuilds the in-stock / low-stock / sold-out badge for the selected variant,
  // mirroring the server render in dw-main-product.liquid. Inline SVGs match the
  // 'warning' + 'check' icons from dw-icon.liquid (same approach as the star
  // markup in dw-social-proof.js).
  function dwStockIcon(name) {
    var paths = {
      warning:
        '<path d="M236.8,188.09,149.35,36.22a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09Z" opacity="0.2"/><path d="M120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm116.84,53.61A23.81,23.81,0,0,1,216,228H40a24,24,0,0,1-20.77-36L107.79,40a24,24,0,0,1,40.43,0l88.55,152A23.65,23.65,0,0,1,236.84,197.61ZM222.93,200,134.39,48a8,8,0,0,0-13.5,0L32.41,200a8,8,0,0,0,6.92,12h177.5a8,8,0,0,0,6.92-12ZM128,160a12,12,0,1,0,12,12A12,12,0,0,0,128,160Z"/>',
      check:
        '<path d="M232,56V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56Z" opacity="0.2"/><path d="M205.66,85.66l-96,96a8,8,0,0,1-11.32,0l-40-40a8,8,0,0,1,11.32-11.32L104,164.69l90.34-90.35a8,8,0,0,1,11.32,11.32Z"/>',
    };
    if (!paths[name]) return '';
    return '<svg class="dw-icon dw-icon--sm dw-icon--' + name + '" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" focusable="false">' + paths[name] + '</svg>';
  }

  function dwStockBadgeHtml(info) {
    // info: { qty: number|null, available: bool } — qty is only ever 1–10 (low) or null.
    if (!info || info.available === false) {
      return '<span class="dw-badge dw-badge--out-of-stock"><span>Sold Out</span></span>';
    }
    if (typeof info.qty === 'number' && info.qty > 0 && info.qty <= 10) {
      return '<span class="dw-badge dw-badge--low-stock">' + dwStockIcon('warning') + '<span>Only ' + info.qty + ' left</span></span>';
    }
    return '<span class="dw-badge dw-badge--in-stock">' + dwStockIcon('check') + '<span>In Stock</span></span>';
  }

  // ---- Quantity cap ----
  // Keeps the quantity within [1, max] where max is the on-hand stock (set as the
  // input's `max` when the variant is tracked and overselling is off). Disables
  // the "+" button at the ceiling and surfaces a hint so shoppers can't try to
  // buy more than we have. Operates on a [data-product-root] (PDP / quick view).
  function dwQtyCeiling(input) {
    var m = parseInt(input.getAttribute('max'), 10);
    return (m && m > 0) ? m : Infinity;
  }
  function dwClampQty(scope) {
    var input = scope.querySelector('[data-quantity-input]') || scope.querySelector('.dw-product__quantity-input');
    if (!input) return;
    var max = dwQtyCeiling(input);
    var v = parseInt(input.value, 10);
    if (!v || v < 1) v = 1;
    if (v > max) v = max;
    input.value = v;

    var incBtn = scope.querySelector('.dw-product__quantity-btn[data-action="increase"]');
    if (incBtn) incBtn.disabled = (max !== Infinity && v >= max);

    var hint = scope.querySelector('[data-qty-hint]');
    if (hint) {
      hint.classList.remove('is-error');
      if (max !== Infinity && v >= max) {
        hint.textContent = "That's all we have — only " + max + " in stock.";
        hint.hidden = false;
      } else {
        hint.hidden = true;
      }
    }
  }

  // ---- Registration buy box (classes/events) ----
  // The terms gate (required agreement + typed e-signature) and the seats
  // counter only exist when registration mode is on; these helpers no-op
  // otherwise, so the standard PDP path is unchanged.

  // True when a registration agreement exists and isn't yet complete.
  function dwTermsLocked(root) {
    var gate = root.querySelector('[data-terms-gate]');
    if (!gate) return false;
    var cb = gate.querySelector('[data-terms-agree]');
    var nameEl = gate.querySelector('[data-terms-name]');
    var cbOk = !cb || cb.checked;
    var nameOk = !nameEl || nameEl.value.trim().length > 1;
    return !(cbOk && nameOk);
  }

  function dwAtcLabel(btn, available) {
    if (!available) return 'Sold Out';
    return (btn && btn.dataset.labelAvailable) || 'Add to Cart';
  }

  // Single source of truth for the inline + sticky ATC enabled state and label.
  // Combines variant availability (root[data-available]) with the terms gate.
  function dwApplyAtcState(root) {
    var available = root.dataset.available !== 'false';
    var locked = dwTermsLocked(root);
    var atcBtn = root.querySelector('[data-atc]');
    if (atcBtn) {
      var atcLabel = atcBtn.querySelector('[data-atc-label]') || atcBtn.querySelector('span');
      atcBtn.disabled = !available || locked;
      if (atcLabel) atcLabel.textContent = dwAtcLabel(atcBtn, available);
    }
    // Sticky mobile bar lives outside the root and is owned by the PDP only.
    if (root.dataset.updateUrl === '1') {
      var sBtn = document.querySelector('#DwStickyAtc [data-sticky-atc]');
      if (sBtn) {
        var sLabel = sBtn.querySelector('[data-sticky-atc-label]');
        sBtn.disabled = !available || locked;
        if (sLabel) sLabel.textContent = dwAtcLabel(sBtn, available);
      }
    }
    var gate = root.querySelector('[data-terms-gate]');
    if (gate) gate.classList.toggle('is-locked', locked && available);
  }

  // Seats counter — driven by the selected variant's Shopify inventory.
  function dwUpdateSeats(root, variant) {
    var box = root.querySelector('[data-seats]');
    if (!box || !variant) return;
    if (variant.inventory_management !== 'shopify') { box.hidden = true; return; }
    var threshold = parseInt(box.dataset.threshold, 10) || 8;
    var qty = typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : 0;
    box.hidden = false;
    box.classList.remove('is-plentiful', 'is-low', 'is-full');
    if (qty > threshold) {
      box.classList.add('is-plentiful');
      box.textContent = 'Seats available — reserve yours';
    } else if (qty > 0) {
      box.classList.add('is-low');
      box.textContent = 'Only ' + qty + ' seat' + (qty === 1 ? '' : 's') + ' left';
    } else {
      box.classList.add('is-full');
      box.textContent = 'Class full — join the waitlist below';
    }
  }

  function initTermsGate(root) {
    var gate = root.querySelector('[data-terms-gate]');
    if (!gate || gate.dataset.dwGateInit === '1') return;
    gate.dataset.dwGateInit = '1';
    var recompute = function () { dwApplyAtcState(root); };
    gate.querySelectorAll('[data-terms-agree], [data-terms-name]').forEach(function (el) {
      el.addEventListener('change', recompute);
      el.addEventListener('input', recompute);
    });
    recompute(); // lock the ATC on load until the shopper agrees
  }

  // ---- Live variant picker ----
  // Expects a [data-product-root] containing:
  //   <script type="application/json" data-product-variants>[...]</script>
  //   inputs [data-product-option][data-option-position]
  //   input[name="id"], [data-product-price], [data-atc], [data-product-main-image]
  function initVariantPicker(root) {
    if (!root || root.dataset.dwVariantInit === '1') return;
    const dataEl = root.querySelector('[data-product-variants]');
    if (!dataEl) return;

    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.dataset.dwVariantInit = '1';

    // Per-variant stock map (id -> { qty, available }) for the live stock badge.
    let inventory = {};
    const invEl = root.querySelector('[data-product-inventory]');
    if (invEl) { try { inventory = JSON.parse(invEl.textContent); } catch (e) { inventory = {}; } }
    const stockBox = root.querySelector('[data-product-stock]');

    const idInput = root.querySelector('input[name="id"]');
    const priceEl = root.querySelector('[data-product-price]');
    const savingsEl = root.querySelector('[data-product-savings]');
    const atcBtn = root.querySelector('[data-atc]');
    const atcLabel = atcBtn ? atcBtn.querySelector('[data-atc-label]') || atcBtn.querySelector('span') : null;
    const mainImg = root.querySelector('[data-product-main-image]');
    const optionInputs = root.querySelectorAll('[data-product-option]');

    // Sticky mobile buy bar lives OUTSIDE [data-product-root], and only the PDP
    // (not the quick-view modal) owns it. Keep its price + ATC state in sync.
    const isPdpRoot = root.dataset.updateUrl === '1';
    const stickyPriceEl = isPdpRoot ? document.querySelector('[data-sticky-atc-price]') : null;

    function selectedByPosition() {
      const map = {};
      optionInputs.forEach(function (input) {
        if ((input.type === 'radio' || input.type === 'checkbox') && !input.checked) return;
        map[input.dataset.optionPosition] = input.value;
      });
      return map;
    }

    function findVariant(map) {
      const positions = Object.keys(map);
      return variants.find(function (v) {
        return positions.every(function (pos) {
          return v.options[pos - 1] === map[pos];
        });
      });
    }

    function update() {
      const variant = findVariant(selectedByPosition());

      // Update the visible "selected value" labels per option group
      optionInputs.forEach(function (input) {
        if (input.checked) {
          const legendStrong = root.querySelector('[data-selected-for="' + input.dataset.optionPosition + '"]');
          if (legendStrong) legendStrong.textContent = input.value;
          const label = input.closest('.dw-product__option-value');
          if (label) {
            const siblings = label.parentElement.querySelectorAll('.dw-product__option-value');
            siblings.forEach(function (s) { s.classList.remove('dw-product__option-value--active'); });
            label.classList.add('dw-product__option-value--active');
          }
        }
      });

      if (!variant) {
        root.dataset.available = 'false';
        if (atcBtn) { atcBtn.disabled = true; if (atcLabel) atcLabel.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;

      // Shipping eligibility follows the variant, not the product. The bars are
      // pre-rendered by Liquid (one per variant) so the copy has a single home;
      // this only decides which one is on screen.
      const shipWrap = root.querySelector('[data-ship-note]');
      if (shipWrap) {
        shipWrap.querySelectorAll('[data-ship-for]').forEach(function (el) {
          el.hidden = el.getAttribute('data-ship-for') !== String(variant.id);
        });
      }

      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (priceEl) {
        // Rebuild full price markup to match the dw-price snippet — current,
        // compare-at, Save % pill, and unit price (which the old build dropped).
        let html = '<span class="dw-price__current">' + money(variant.price) + '</span>';
        if (onSale) {
          const pct = Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          html += ' <s class="dw-price__compare">' + money(variant.compare_at_price) + '</s>';
          html += ' <span class="dw-price__save">Save ' + pct + '%</span>';
        }
        if (variant.unit_price && variant.unit_price_measurement) {
          const m = variant.unit_price_measurement;
          const ref = m.reference_value === 1
            ? '/' + m.reference_unit
            : '/' + m.reference_value + ' ' + m.reference_unit;
          html += ' <span class="dw-price__unit">' + money(variant.unit_price) + ref + '</span>';
        }
        priceEl.innerHTML = '<div class="dw-price dw-price--lg' + (onSale ? ' dw-price--sale' : '') + '">' + html + '</div>';
      }

      // Savings line beneath the price (red urgency treatment)
      if (savingsEl) {
        if (onSale) {
          const amt = variant.compare_at_price - variant.price;
          const pct = Math.floor(amt * 100 / variant.compare_at_price);
          const inner = savingsEl.querySelector('span');
          const text = 'You save <strong>' + money(amt) + '</strong> (' + pct + '% off)';
          if (inner) { inner.innerHTML = text; } else { savingsEl.innerHTML = '<span>' + text + '</span>'; }
          savingsEl.hidden = false;
        } else {
          savingsEl.hidden = true;
        }
      }

      // Availability + label for inline and sticky ATC, combined with the terms
      // gate (registration mode). dwApplyAtcState reads root[data-available].
      root.dataset.available = variant.available ? 'true' : 'false';
      dwApplyAtcState(root);
      // Mirror price onto the sticky mobile buy bar (PDP only).
      if (stickyPriceEl) stickyPriceEl.textContent = money(variant.price);
      // Seats counter follows the selected variant's inventory (registration mode).
      dwUpdateSeats(root, variant);
      // Live stock badge for the selected variant (in-stock / low-stock / sold-out).
      if (stockBox) {
        const info = inventory[variant.id] || { qty: null, available: variant.available };
        stockBox.innerHTML = dwStockBadgeHtml(info);
      }
      // Quantity cap follows the selected variant's on-hand stock.
      const qtyInput = root.querySelector('[data-quantity-input]');
      if (qtyInput) {
        const invRow = inventory[variant.id];
        const cap = invRow && typeof invRow.max === 'number' ? invRow.max : null;
        if (cap !== null && cap > 0) { qtyInput.setAttribute('max', cap); } else { qtyInput.removeAttribute('max'); }
        dwClampQty(root);
      }
      if (mainImg && variant.featured_image && variant.featured_image.src) {
        // Variant has its own image — show it full-res and drop the featured srcset.
        mainImg.removeAttribute('srcset');
        mainImg.src = variant.featured_image.src;
        // Sync the active thumbnail to this variant's media, if it's in the strip.
        const mediaId = variant.featured_media && variant.featured_media.id;
        if (mediaId != null) {
          root.querySelectorAll('.dw-product__gallery-thumb').forEach(function (b) {
            const match = String(b.dataset.mediaId) === String(mediaId);
            b.classList.toggle('is-active', match);
            b.setAttribute('aria-pressed', match ? 'true' : 'false');
          });
        }
      }
      // Refresh in-store pickup availability for the newly selected variant
      const pickup = root.querySelector('pickup-availability');
      if (pickup && typeof pickup.update === 'function') pickup.update(variant);
      // Reflect variant in URL (PDP only, not quick view)
      if (root.dataset.updateUrl === '1' && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', update);
    });

    // Clamp the quantity to on-hand stock right before a native (PDP) form submit,
    // in case the shopper typed a number straight into the field.
    const buyForm = root.querySelector('.dw-product__form');
    if (buyForm && buyForm.dataset.dwQtyClamp !== '1') {
      buyForm.dataset.dwQtyClamp = '1';
      buyForm.addEventListener('submit', function () { dwClampQty(root); });
    }
  }

  // Quantity steppers (shared) — clamp to on-hand stock via dwClampQty.
  function initQtySteppers(root) {
    (root || document).querySelectorAll('.dw-product__quantity:not([data-dw-qty-init])').forEach(function (group) {
      group.dataset.dwQtyInit = '1';
      const input = group.querySelector('.dw-product__quantity-input');
      if (!input) return;
      const scope = group.closest('[data-product-root]') || group;
      group.querySelectorAll('.dw-product__quantity-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          let v = parseInt(input.value, 10) || 1;
          v = btn.dataset.action === 'increase' ? v + 1 : Math.max(1, v - 1);
          input.value = v;
          dwClampQty(scope);
        });
      });
      input.addEventListener('change', function () { dwClampQty(scope); });
      input.addEventListener('input', function () { dwClampQty(scope); });
      dwClampQty(scope); // set initial +button/hint state (e.g. a variant with max 1)
    });
  }

  // Thumbnail gallery (shared) — swap the main image instantly. Thumbs carry a
  // data-full (1200w) URL; we set src and clear srcset so the browser shows the
  // chosen full-res image rather than re-resolving the featured srcset.
  function initGallery(root) {
    const scope = root || document;
    const main = scope.querySelector('[data-product-main-image]');
    if (!main) return;
    const thumbs = scope.querySelectorAll('.dw-product__gallery-thumb');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const full = btn.dataset.full ||
          (btn.querySelector('img') && btn.querySelector('img').src.replace(/width=\d+/, 'width=1200'));
        if (!full) return;
        main.removeAttribute('srcset');
        main.src = full;
        thumbs.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
      });
    });
  }

  function initProductRoot(root) {
    initVariantPicker(root);
    initQtySteppers(root);
    initGallery(root);
    initTermsGate(root);
  }

  // Init the main PDP on load
  document.querySelectorAll('[data-product-root]').forEach(initProductRoot);

  // Quick-view add-to-cart (AJAX) — buying from the modal shouldn't reload the
  // whole page. Intercept the form submit, POST to /cart/add.js, fly the image
  // to the header cart, sync the badge, then close. The Shop Pay / dynamic
  // checkout button is a separate element and bypasses this submit untouched.
  function initQuickViewForm(root) {
    const form = root.querySelector('[data-quick-view-form]') || root.querySelector('form');
    if (!form || form.dataset.dwQvInit === '1') return;
    form.dataset.dwQvInit = '1';

    const atcBtn = form.querySelector('[data-atc]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!atcBtn || atcBtn.disabled || atcBtn.classList.contains('is-loading')) return;

      const idInput = form.querySelector('input[name="id"]');
      const qtyInput = form.querySelector('[name="quantity"]');
      const variantId = idInput && idInput.value;
      if (!variantId) return;
      const quantity = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);

      const img = root.querySelector('[data-product-main-image]');
      dwFlyToCart(img);

      const atcLabel = atcBtn.querySelector('[data-atc-label]') || atcBtn.querySelector('span');
      const prevLabel = atcLabel ? atcLabel.textContent : '';
      atcBtn.classList.add('is-loading');
      if (atcLabel) atcLabel.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity }),
      })
        .then(function (r) { if (!r.ok) throw new Error('ATC failed'); return r.json(); })
        .then(function () {
          dwSyncCart();
          if (atcLabel) atcLabel.textContent = 'Added ✓';
          dwFlashAdded(atcBtn);
          dwCelebrate(atcBtn, { count: 8, sound: 'take' });
          dwFoam(atcBtn);
          if (!img || dwReducedMotion) dwBumpCart();
          setTimeout(closeQuickView, 650);
        })
        .catch(function (err) {
          console.warn('DW quick view add failed', err);
          if (atcLabel) atcLabel.textContent = prevLabel || 'Add to Cart';
        })
        .finally(function () {
          setTimeout(function () { atcBtn.classList.remove('is-loading'); }, 650);
        });
    });
  }

  // ---- Quick view ----
  const qvModal = document.getElementById('DwQuickView');
  function openQuickView(url) {
    if (!qvModal) { return false; }
    const content = qvModal.querySelector('[data-quick-view-content]');
    qvModal.classList.add('is-open');
    qvModal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    content.innerHTML = '<div class="dw-quick-view__loading">Loading…</div>';

    fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        // Only inject the quick-view section. If the marker is missing, the
        // response was a full page (e.g. a URL with tracking params bypassed
        // ?view=quick-view) — link out instead of dumping the whole site in.
        const inner = tmp.querySelector('[data-quick-view-inner]');
        if (!inner) {
          content.innerHTML = '<div class="dw-quick-view__loading">View the <a href="' + url.split('?')[0] + '">full product details</a>.</div>';
          return;
        }
        content.innerHTML = inner.innerHTML;
        const root = content.querySelector('[data-product-root]');
        if (root) {
          initProductRoot(root);
          initQuickViewForm(root);
        }
      })
      .catch(function (err) {
        console.warn('DW quick view failed', err);
        content.innerHTML = '<div class="dw-quick-view__loading">Could not load. <a href="' + url.split('?')[0] + '">View full product</a></div>';
      });
    return true;
  }
  function closeQuickView() {
    if (!qvModal) return;
    qvModal.classList.remove('is-open');
    qvModal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-quick-view-url]');
    if (trigger) {
      const opened = openQuickView(trigger.getAttribute('data-quick-view-url'));
      if (opened) e.preventDefault();
      return;
    }
    if (qvModal && (e.target.closest('[data-quick-view-close]') ||
        (e.target.classList && e.target.classList.contains('dw-modal__backdrop') && e.target.closest('#DwQuickView')))) {
      e.preventDefault();
      closeQuickView();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeQuickView();
  });

  // ---- Read more / less (collection description, etc.) ----
  document.addEventListener('click', function (e) {
    const toggle = e.target.closest('[data-readmore-toggle]');
    if (!toggle) return;
    e.preventDefault();
    const wrap = toggle.closest('[data-readmore]');
    if (!wrap) return;
    const expanded = wrap.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  });

  // ---- Product video facade: load the YouTube/Vimeo embed only on tap (speed) ----
  // Posters render on page load; the heavy iframe is created only when the shopper
  // actually wants to watch, keeping the PDP fast.
  document.addEventListener('click', function (e) {
    const facade = e.target.closest('[data-video-facade]');
    if (!facade) return;
    const embed = facade.getAttribute('data-video-embed');
    if (!embed) return;
    e.preventDefault();
    const wrap = document.createElement('div');
    wrap.className = 'dw-product-video__embed';
    wrap.setAttribute('tabindex', '-1');
    const iframe = document.createElement('iframe');
    iframe.src = embed;
    iframe.title = facade.getAttribute('data-video-title') || 'Video';
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
    iframe.setAttribute('allowfullscreen', '');
    wrap.appendChild(iframe);
    facade.replaceWith(wrap);
    // Keep keyboard/AT users anchored on the now-playing video (replaceWith drops
    // focus to <body>, resetting their tab position otherwise).
    wrap.focus();
  });

  // ---- Card quantity stepper (local "how many to add" picker) ----
  // Just adjusts the number to add; the cart isn't touched until Add to Cart.
  document.addEventListener('click', function (e) {
    const step = e.target.closest('[data-step]');
    if (!step) return;
    const stepper = step.closest('[data-card-stepper]');
    if (!stepper) return;
    e.preventDefault();

    const qtyEl = stepper.querySelector('[data-step-qty]');
    const max = stepper.dataset.max ? parseInt(stepper.dataset.max, 10) : null;
    const current = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;
    let next = step.getAttribute('data-step') === 'up' ? current + 1 : current - 1;

    if (next < 1) next = 1; // local picker floors at 1 — removal happens in the cart
    var blocked = false;
    if (max !== null && next > max) {
      next = max;
      blocked = true;
      stepper.classList.add('is-maxed'); // flash: can't add more than on-hand stock
      setTimeout(function () { stepper.classList.remove('is-maxed'); }, 400);
    }

    // This is the gesture a reordering Pro repeats dozens of times a session —
    // the highest-frequency interaction on the site, so it earns real feedback.
    // A blocked step is a DENY (low, longer buzz), never a celebration.
    if (blocked || next === current) {
      if (window.DwTap) window.DwTap('deny');
      if (window.DwSfx) window.DwSfx.deny();
    } else {
      if (window.DwTap) window.DwTap('tap');
      if (window.DwSfx) window.DwSfx.tick();
    }

    if (qtyEl) qtyEl.textContent = next;
  });

  // Refresh the header badge / drawer contents WITHOUT forcing the drawer open
  // (dw-chrome.js listens for this and re-fetches /cart.js).
  function dwSyncCart() {
    document.dispatchEvent(new CustomEvent('dw:cart:updated'));
  }

  const dwReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Shared celebration helpers -----------------------------------------
     These all resolve through window.DwMotion / DwTap / DwSfx / DwBurst, which
     dw-chrome.js defines. chrome.js loads first (theme.liquid) but every call
     below is still guarded, because a section can render without it and a dead
     add-to-cart button is a far worse outcome than a missing sparkle. */

  function dwCelebrate(anchor, opts) {
    opts = opts || {};
    if (window.DwBurst) window.DwBurst(anchor, opts);
    if (window.DwTap) window.DwTap(opts.haptic || 'tap');
    if (window.DwSfx && opts.sound) window.DwSfx[opts.sound]();
  }

  // Suds drifting up off the button. Appended to <body>, not the button —
  // .dw-btn is overflow:hidden (it clips the sheen) and would eat every bubble.
  function dwFoam(anchor) {
    if (!anchor || !window.DwMotion || !window.DwMotion.celebrate) return;
    var rect = anchor.getBoundingClientRect();
    if (!rect.width) return;
    var host = document.createElement('div');
    host.className = 'dw-foam';
    host.style.left = rect.left + rect.width / 2 + 'px';
    host.style.top = rect.top + 'px';
    for (var i = 0; i < 7; i++) {
      var b = document.createElement('i');
      var size = 6 + Math.random() * 11;
      b.style.width = size + 'px';
      b.style.height = size + 'px';
      b.style.setProperty('--dx', (Math.random() * 64 - 32).toFixed(1) + 'px');
      b.style.setProperty('--delay', (Math.random() * 220).toFixed(0) + 'ms');
      host.appendChild(b);
    }
    document.body.appendChild(host);
    setTimeout(function () { if (host.parentNode) host.parentNode.removeChild(host); }, 1400);
  }

  // Turn the button itself green for a beat. A shopper mid-scroll reads colour
  // before text, and the label alone ("Added ✓") is easy to miss.
  function dwFlashAdded(btn) {
    if (!btn) return;
    btn.classList.add('is-added');
    setTimeout(function () { btn.classList.remove('is-added'); }, 1100);
  }

  // Pop the header cart icon so the landing registers even mid-scroll.
  function dwBumpCart() {
    const icon = document.querySelector('.dw-header__action--cart .dw-header__action-icon');
    if (!icon) return;
    icon.classList.remove('dw-cart-bump');
    void icon.offsetWidth; // restart the animation
    icon.classList.add('dw-cart-bump');
    icon.addEventListener('animationend', function () { icon.classList.remove('dw-cart-bump'); }, { once: true });
  }

  // Fly a clone of the product image into the header cart icon. Geometry is
  // computed live (left/top/transform); timing + look live in CSS (.dw-fly-clone).
  // Calls onLanded when it arrives (or immediately if it can't run).
  function dwFlyToCart(img, onLanded) {
    const target = document.querySelector('.dw-header__action--cart .dw-header__action-icon')
      || document.querySelector('[data-drawer-open="DwCartDrawer"]');
    if (!img || !target || dwReducedMotion) { if (onLanded) onLanded(); return; }

    const start = img.getBoundingClientRect();
    const end = target.getBoundingClientRect();
    if (!start.width || !end.width) { if (onLanded) onLanded(); return; }

    const clone = img.cloneNode(true);
    clone.removeAttribute('loading');
    clone.className = 'dw-fly-clone';
    clone.style.left = start.left + 'px';
    clone.style.top = start.top + 'px';
    clone.style.width = start.width + 'px';
    clone.style.height = start.height + 'px';
    document.body.appendChild(clone);

    const dx = end.left + end.width / 2 - (start.left + start.width / 2);
    const dy = end.top + end.height / 2 - (start.top + start.height / 2);

    let landed = false;
    const land = function () {
      if (landed) return;
      landed = true;
      clone.remove();
      dwBumpCart();
      if (onLanded) onLanded();
    };
    clone.addEventListener('transitionend', land, { once: true });
    // Safety net in case transitionend never fires.
    setTimeout(land, 800);

    // Double rAF so the start position paints before we animate to the cart.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        clone.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.18)';
        clone.style.opacity = '0.35';
      });
    });
  }

  // ---- Card add-to-cart: fly the image to the cart, then sync the badge ----
  // No forced drawer open — the fly + badge pop is the feedback, so Pros can
  // keep adding without the drawer interrupting every tap.
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;

    const variantId = btn.getAttribute('data-quick-add');
    const card = btn.closest('.dw-product-card');
    let quantity = 1;
    if (card) {
      const qtyEl = card.querySelector('[data-step-qty]');
      if (qtyEl) quantity = parseInt(qtyEl.textContent, 10) || 1;
    }

    // Kick the animation off immediately so the add feels instant.
    const img = card && card.querySelector('.dw-product-card__media img');
    dwFlyToCart(img);

    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity }),
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          // Over-stock (already at on-hand in the cart) or other rejection — flash the
          // stepper and briefly say so, rather than failing silently.
          var stepper = card && card.querySelector('[data-card-stepper]');
          if (stepper) { stepper.classList.add('is-maxed'); setTimeout(function () { stepper.classList.remove('is-maxed'); }, 700); }
          var label = btn.querySelector('.dw-product-card__add-label');
          if (label) { var prev = label.textContent; label.textContent = "That's all in stock"; setTimeout(function () { label.textContent = prev; }, 1800); }
          // A refusal is not a celebration: short, low, no burst, no gold.
          if (window.DwTap) window.DwTap('deny');
          if (window.DwSfx) window.DwSfx.deny();
          return;
        }
        dwSyncCart();
        // Reset the picker back to 1 for the next add.
        if (card) {
          const qtyEl = card.querySelector('[data-step-qty]');
          if (qtyEl) qtyEl.textContent = '1';
        }
        // Confirm at the finger, not just in the header — on a phone the cart
        // badge is often off-screen behind the thumb.
        dwFlashAdded(btn);
        dwCelebrate(btn, { count: 8, sound: 'take' });
        dwFoam(btn);
        // If the image couldn't fly (no image / reduced motion), still pop the badge.
        if (!img || dwReducedMotion) dwBumpCart();
      })
      .catch(function (err) { console.warn('DW quick add failed', err); })
      .finally(function () { btn.classList.remove('is-loading'); });
  });

  // ---- Collection: type-ahead search inside long filter lists ----
  document.addEventListener('input', function (e) {
    const search = e.target.closest('[data-filter-search]');
    if (!search) return;
    const body = search.closest('.dw-filter__body');
    if (!body) return;
    const q = search.value.trim().toLowerCase();
    body.querySelectorAll('.dw-filter__list > li').forEach(function (li) {
      li.style.display = !q || li.textContent.toLowerCase().indexOf(q) !== -1 ? '' : 'none';
    });
  });

  // ---- Sticky ATC bar (mobile conversion) ----
  // Persistent mobile checkout rail: the bar is visible whenever the real
  // Add-to-Cart button is NOT fully on screen. On mobile the inline ATC sits
  // below the image, so the bar shows from first paint (price + tap-to-add
  // above the fold) and only yields once the shopper scrolls the inline ATC
  // fully into view — no competing double-CTA. Desktop hides it via CSS.
  const stickyBar = document.getElementById('DwStickyAtc');
  const mainAtc = document.querySelector('[data-product-root] [data-atc]');
  if (stickyBar && mainAtc && 'IntersectionObserver' in window) {
    // The fixed bar covers the bottom strip of the viewport, so treat the inline
    // ATC as "fully visible" only once it clears the bar's height — otherwise the
    // bar would retract while still overlapping the button. Measured, not magic.
    const barH = stickyBar.offsetHeight || 64;
    const setSticky = function (atcFullyVisible) {
      const visible = !atcFullyVisible;
      stickyBar.classList.toggle('is-visible', visible);
      // Keep the a11y tree in step with what's on screen: when off-screen the bar
      // is inert + hidden; when shown its ATC is reachable/announceable.
      stickyBar.toggleAttribute('inert', !visible);
      stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };
    const obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setSticky(entry.isIntersecting); // threshold:1 => true only when 100% within the inset root
      });
    }, { threshold: 1, rootMargin: '0px 0px -' + barH + 'px 0px' });
    obs.observe(mainAtc);

    // Reflect the correct state before the first scroll so there's no flash of
    // the wrong state on load (IntersectionObserver's initial callback is async).
    requestAnimationFrame(function () {
      const r = mainAtc.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      setSticky(r.top >= 0 && r.bottom <= vh - barH);
    });

    const stickyBtn = stickyBar.querySelector('[data-sticky-atc]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        // If the only blocker is the registration terms gate, send the shopper
        // to it (and flash it) instead of a dead tap on a disabled button.
        if (mainAtc.disabled) {
          const root = mainAtc.closest('[data-product-root]');
          const gate = root && root.querySelector('[data-terms-gate]');
          if (gate && root.dataset.available !== 'false') {
            gate.scrollIntoView({ behavior: 'smooth', block: 'center' });
            gate.classList.add('is-flash');
            setTimeout(function () { gate.classList.remove('is-flash'); }, 600);
            const field = gate.querySelector('[data-terms-name]') || gate.querySelector('[data-terms-agree]');
            if (field) { try { field.focus({ preventScroll: true }); } catch (e) { field.focus(); } }
          }
          return;
        }
        mainAtc.click();
      });
    }
  }
})();
